import { render, staticRenderFns } from "./VMyAccountPage.vue?vue&type=template&id=7f0db8d0&"
import script from "./VMyAccountPage.vue?vue&type=script&lang=js&"
export * from "./VMyAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports